<div
  class="card-body"
  *ngIf="config && config.categoria && config.categoria.noticias && config.categoria.noticias.length > 0"
>
  <div
    class="card-title"
    *ngIf="config.mostrar_titulo == 1"
    [ngStyle]="{'color': getFontColor()}"
  >
    {{config.categoria.categoria}}
  </div>

  <ng-container *ngFor="let noticia of noticiaList; index as i">
    <div
      class="d-flex border-bottom-dotted-dim pb-2 mb-2 lista"
      (click)="abrirNoticia(noticia)"
    >
      <img
        class="avatar-md rounded mr-3"
        [src]="noticia.imagemApp | image:' '"
      />
      <div class="flex-grow-1">
        <h6 class="m-0 titulo" [ngStyle]="{'color': getFontColor()}">
          {{noticia.titulo}}
        </h6>
        <p
          class="m-0 text-small subtitulo"
          [ngStyle]="{'color': getFontColor()}"
        >
          {{noticia.subtitulo}}
        </p>

        <p
          *ngIf="config.categoria.mostrar_data == '1'"
          class="m-0 text-small subtitulo"
          [ngStyle]="{'color': getFontColor()}"
        >
          {{noticia.divulgarDe | dateFormat: "curta" }}
        </p>
      </div>
    </div>
  </ng-container>

  <div class="ver-todos" *ngIf="maximoNoticia && maximoNoticia.maximo">
    <ion-button 
      shape="round"
      fill="outline"
      size="small"
      color="medium"
      class="button-filter"
      (click)="abrirCategoria()"
    >
      {{'VER TODOS' | translate}}
    </ion-button>
  </div>
</div>

<div
  *ngIf="config && config.categoria && config.categoria.noticias && config.categoria.noticias.length == 0"
>
  <p class="m-0 text-small text-center">Nenhuma {{"noticia" | nomenclatura | async}} Ativa</p>
</div>
